import { cn } from "@/flokit/utils/styling/cn";
import { FiSearch } from "react-icons/fi";

export const Searchbar = (props: {
  onChange: (value: string) => void;
  value: string;
  placeholder?: string;
  position?: "left" | "right";
  ariaLabel: string;
  disabled?: boolean;
  /**
   * @deprecated this likely shouldn't be a prop, but this component is 3 yrs old and don't want to break existing designs. Check with design what border radius we're using. Using this now because it is often placed next to menus with larger radius and looks obviously bad otherwise
   */
  roundedMd?: boolean;
}) => {
  const pos = props.position || "left";
  return (
    <div className="relative flex w-full items-center">
      <div
        className={`pointer-events-none absolute flex h-8 w-11 items-center justify-center ${
          pos === "left" ? "left-0" : "right-0"
        }`}
      >
        <FiSearch size={16} />
      </div>
      <input
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        className={cn(
          `border-dublin-gray w-full border px-4 py-2 text-base ${
            pos === "left" ? "pl-10" : "pr-10"
          }`,
          props.roundedMd ? "rounded-md" : "rounded",
        )}
        type="search"
        placeholder={props.placeholder || "Search..."}
        aria-label={props.ariaLabel}
        disabled={props.disabled ?? false}
      />
    </div>
  );
};

export default Searchbar;
